"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToUrl = redirectToUrl;
exports.redirectToDomain = redirectToDomain;
exports.maybeRedirectToHubSpotDomain = maybeRedirectToHubSpotDomain;
exports.getAdminDomain = getAdminDomain;
exports.getLongDisplayName = getLongDisplayName;
exports.getIsRoundRobin = getIsRoundRobin;
exports.getLinkEditParam = getLinkEditParam;
exports.getHeaderType = getHeaderType;
exports.getHeaderOptions = getHeaderOptions;
exports.setDocumentTitle = setDocumentTitle;
exports.isWhitespace = isWhitespace;
exports.isEmpty = isEmpty;
exports.formatCustomFormFields = formatCustomFormFields;
exports.getOnlineOfflineBookableUsers = getOnlineOfflineBookableUsers;
exports.getRoundRobinUserIdToBook = getRoundRobinUserIdToBook;
exports.shouldIncludeDeleted = shouldIncludeDeleted;
exports.getDomain = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var TimeRangeListUtils = _interopRequireWildcard(require("MeetingsBase/utils/TimeRangeListUtils"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _enums = require("MeetingsBase/constants/enums");

var _utils = require("MeetingsBase/utils/utils");

var _paths = require("MeetingsLib/constants/paths");

var _analytics = require("MeetingsLib/utils/analytics");

function urlWithCrossDomainTracking(url) {
  var identityInfo = (0, _analytics.getHubSpotIdentityInfo)();
  var firstSeparator = url.indexOf('?') !== -1 ? '&' : '?';
  return Object.keys(identityInfo).reduce(function (accUrl, param, idx) {
    var separator = idx ? '&' : firstSeparator;
    return "" + accUrl + separator + param + "=" + identityInfo[param];
  }, url);
}

function redirectToUrl(url) {
  var embedded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Support cross domain tracking https://issues.hubspotcentral.com/browse/SMMC-1524
  var sourceDomain = (0, _analytics.getUrlDomain)(window.location.href);
  var redirectDomain = (0, _analytics.getUrlDomain)(url);
  var redirectUrl = sourceDomain === redirectDomain ? url : urlWithCrossDomainTracking(url);

  if (embedded) {
    window.top.location.href = redirectUrl;
  } else {
    window.location.assign(redirectUrl);
  }
}

function redirectToDomain(domain) {
  window.location.host = domain;
}

function maybeRedirectToHubSpotDomain(domain) {
  if (domain === _paths.wrongHubSpotDomain) {
    redirectToDomain(_paths.hubSpotDomain);
  } else if (domain === _paths.wrongHubSpotQADomain) {
    redirectToDomain(_paths.hubSpotQADomain);
  }
}

var getDomain = function getDomain(email) {
  return email.replace(/.*@/, '');
};

exports.getDomain = getDomain;

function getAdminDomain() {
  return (0, _utils.isQA)() ? _paths.hubSpotQADomain : _paths.hubSpotDomain;
}

function getLongDisplayName(profile) {
  if (profile.firstName && profile.lastName) {
    return (0, _formatName.default)({
      firstName: profile.firstName,
      lastName: profile.lastName
    });
  }

  return profile.fullName || profile.firstName || profile.name || profile.email;
}

function getIsRoundRobin(linkType) {
  return linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN);
}

function getLinkEditParam(linkType) {
  var isTeamLink = getIsRoundRobin(linkType) || linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.GROUP);

  return isTeamLink ? _enums.LINK_TYPE_PARAMS.get('team') : _enums.LINK_TYPE_PARAMS.get(_enums.MEETING_TYPES.PERSONAL);
}

function getHeaderType(isRoundRobin) {
  return isRoundRobin ? 'roundRobinHeader' : 'header';
}

function getHeaderOptions(isRoundRobin, companyName, profile) {
  return isRoundRobin ? {
    companyName: companyName || getDomain(profile.email)
  } : {
    fullName: getLongDisplayName(profile)
  };
}

function setDocumentTitle(headline, linkType, companyName, profile) {
  var isRoundRobin = getIsRoundRobin(linkType);
  var headerType = getHeaderType(isRoundRobin);
  var options = getHeaderOptions(isRoundRobin, companyName, profile);

  var profileHeader = _I18n.default.text("prebook." + headerType + ".online", options);

  document.title = headline || profileHeader;
}

function getRandomIndex(length) {
  return Math.floor(Math.random() * length);
}

function isWhitespace(value) {
  return typeof value === 'string' && value.trim().length <= 0;
}

function isEmpty(value) {
  return !value || value.trim() === '';
}

function formatCustomFormFields(formFields) {
  return formFields.reduce(function (acc, fieldAnswer, fieldName) {
    if (fieldAnswer === null) {
      // if unrequired field is left blank, don't send anything
      return acc;
    }

    var isDateField = fieldAnswer.year && fieldAnswer.month && fieldAnswer.date;
    var isListField = Array.isArray(fieldAnswer);

    if (isDateField) {
      fieldAnswer = _I18n.default.moment.utc([fieldAnswer.year, fieldAnswer.month, fieldAnswer.date]).valueOf().toString();
    }

    if (isListField) {
      fieldAnswer = fieldAnswer.join(';');
    }

    return acc.push({
      name: fieldName,
      value: fieldAnswer
    });
  }, (0, _immutable.List)());
}

function getOnlineOfflineBookableUsers(bufferTime, meeting, allUsersBusyTimes) {
  var onlineOffline = allUsersBusyTimes.map(function (userBusyTimes) {
    return userBusyTimes.update('busyTimes', function (busyTimes) {
      return TimeRangeListUtils.addBufferTime(busyTimes, bufferTime);
    });
  }).filter(function (paddedUserBusyTimes) {
    return paddedUserBusyTimes.get('busyTimes').every(function (paddedBusyTime) {
      return !paddedBusyTime.hasIntersection(meeting);
    });
  }).groupBy(function (availableUsers) {
    return availableUsers.get('offline');
  });
  return {
    onlineBookableUsers: onlineOffline.get(false),
    offlineBookableUsers: onlineOffline.get(true)
  };
}

function getRoundRobinUserIdToBook(event, allUsersBusyTimes, bufferTime) {
  var dateTime = event.dateTime,
      duration = event.duration;

  var meeting = _TimeRange.default.from({
    start: dateTime,
    end: dateTime + duration
  });

  var _getOnlineOfflineBook = getOnlineOfflineBookableUsers(bufferTime, meeting, allUsersBusyTimes),
      onlineBookableUsers = _getOnlineOfflineBook.onlineBookableUsers,
      offlineBookableUsers = _getOnlineOfflineBook.offlineBookableUsers;

  if (onlineBookableUsers && onlineBookableUsers.size) {
    var chosenUserId = onlineBookableUsers.get(getRandomIndex(onlineBookableUsers.size)).get('id');
    var allUserIds = onlineBookableUsers.map(function (user) {
      return user.get('id');
    });
    return {
      chosenUserId: chosenUserId,
      allUserIds: allUserIds
    };
  } else if (offlineBookableUsers && offlineBookableUsers.size) {
    var _chosenUserId = offlineBookableUsers.get(getRandomIndex(offlineBookableUsers.size)).get('id');

    return {
      chosenUserId: _chosenUserId,
      allUserIds: null
    };
  }

  _Raven.default.captureMessage('No users bookable on round robin link', {
    extra: {
      allUsersBusyTimes: allUsersBusyTimes,
      bufferTime: bufferTime,
      meeting: meeting
    }
  });

  return {
    chosenUserId: null,
    allUserIds: null
  };
}

function shouldIncludeDeleted(params) {
  return (0, _get.default)('includeDeleted', params) || 'false';
}